module.exports = "https://static.wmbcdn.com/uniweb/images/614aef6727c324cdeef22305b65a93bd.svg";